<template>
  <svg viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_48352_215779)">
      <path d="M36.5879 68.9768L64.445 31.834" stroke="currentColor" stroke-width="6.5" stroke-linecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_48352_215779">
        <rect x="0.515625" y="0.40625" width="100" height="100" rx="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
